import React from 'react';

const LoadingSpinner = ({ size = 'large', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  return (
    // dark: variants are REQUIRED here. This is the Suspense fallback for every lazy
    // route (App.js:93), so it paints full-screen on the FIRST visit to each nav item
    // while that chunk downloads. With bg-gray-50 and no dark variant it flashed a
    // near-white panel over a dark-only portal — once per page, returning after every
    // refresh because the module cache is cleared.
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className={`loading-spinner ${sizeClasses[size]} mb-4`}></div>
      <p className="text-gray-600 dark:text-gray-400 text-sm">{text}</p>
    </div>
  );
};

export default LoadingSpinner;
